// Browser key-value stores — canon Phase 4.
// Persistent: cookie (1y) + localStorage backup. Session: sessionStorage.
import type { KeyValueStore } from './types';

export function createPersistentStore(): KeyValueStore {
  return {
    get(key) {
      try {
        const v = localStorage.getItem(key);
        if (v) return v;
      } catch {
        /* storage blocked */
      }
      const match = document.cookie.match(new RegExp(`(?:^|; )${key}=([^;]*)`));
      return match && match[1] ? decodeURIComponent(match[1]) : null;
    },
    set(key, value) {
      try {
        localStorage.setItem(key, value);
      } catch {
        /* ignore */
      }
      const oneYear = 60 * 60 * 24 * 365;
      document.cookie = `${key}=${encodeURIComponent(value)}; Max-Age=${oneYear}; Path=/; SameSite=Lax`;
    },
  };
}

export function createSessionStore(): KeyValueStore {
  return {
    get(key) {
      try {
        return sessionStorage.getItem(key);
      } catch {
        return null;
      }
    },
    set(key, value) {
      try {
        sessionStorage.setItem(key, value);
      } catch {
        /* ignore */
      }
    },
  };
}
